import "../Stylesheet/Footer.css";
import { FaGithub, FaLinkedin, FaInstagram, FaTwitter } from "react-icons/fa";
import { FaRegHeart } from "react-icons/fa";
import { useContext } from "react";
import { LanguageContext } from "../Context/LanguageContext";

export default function Footer() {

  const { t } = useContext(LanguageContext);
  const f = t.footer;

  return (
    <footer className="footer">
      {/* Top Row */}
      <div className="footer-top">
        <div className="footer-left">
          <h3>{f.name}</h3>
          <p>{f.tagline}</p>
        </div>

        <div className="footer-icons">
          <FaGithub />
          <FaLinkedin />
          <FaInstagram />
          <FaTwitter />
        </div>
      </div>

      {/* Bottom Row */}
      <div className="footer-bottom">
        <p>{f.rights}</p>

        <p className="footer-made">
         {f.madeWith} <span><FaRegHeart /></span> {f.using}
        </p>
      </div>
    </footer>
  );
}
